import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { HomeNavbar } from '../../common/home-navbar';
import { DataForm } from './data-form';
import { AppRedirect, routeNaming } from '../../routes';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import styles from './ChangePassword.css';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

const ChangePassword = observer((props) => {
  const { token } = ParamsHelper.parseQueryParams(props.location.search);
  if (!token) {
    return (
      <AppRedirect routeName={routeNaming.NOT_FOUND} />
    );
  }
  return (
    <div className={styles.container}>
      <HomeNavbar />
      <div className={styles.mainContent}>
        <h1 className={styles.title}>Cambiar contraseña</h1>
        <DataForm
          className={styles.form}
          token={token}
        />
      </div>
    </div>
  );
});

ChangePassword.propTypes = IPropTypes;

export { ChangePassword };



// WEBPACK FOOTER //
// ./src/pages/change-password/ChangePassword.jsx